export default {
  orders_summary: (state) => state.orders_summary,
  orders: (state) => state.orders,
  orders_schedule: (state) => state.orders_schedule,
};
